<template>
    <div>
        <!--<div class="arlt-pishtaz" v-if="cart != null && cart.CartInfo.IsApplyFreeDelivery">
            <div class="close-alrt">
                <div class="close close-alert"><i class="fa fa-close"></i></div>
                <div><span>توجه : سود شما ارسال رایگان با پست پیشتاز</span></div>
            </div>
        </div>-->

        <nav class="navbar direction-ltr header-responsive">

            <div class=" " v-if="baseInfo != null">
                <div class="navbar-translate">
                    <div class="">
                        <router-link class="navbar-Category" to="/" :title="baseInfo.ShopName">
                            <img :src="baseInfo.LogoPicPath" height="24px" :title="baseInfo.ShopName" :alt="baseInfo.ShopName">
                        </router-link>

                        <div class="top-fix-i-m">
                            <div @click="closeNav" class="router-a-i-m bascket-i-m">
                                <router-link to="/cart" title="سبد خرید">
                                    <img src="/assets/img/header/cart.png" />
                                </router-link>
                                <span v-if="cart != null" class="countItem">{{  cart.CartInfo.CartDetailsCount }} </span>
                            </div>
                            <div @click="closeNav" class="router-a-i-m">
                                <router-link v-if="isUserLogined" to="/orders" title="پروفایل کاربری">
                                    <img src="/assets/img/header/customer-off.png" />
                                </router-link>
                                <router-link v-if="!isUserLogined" to="/login" title="ورود">
                                    <img src="/assets/img/header/customer-on.png" />
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <div class="d-y-s">
                        <search-box></search-box>
                        <button class="navbar-toggler navbar-toggler-right m-l-15" type="button" data-toggle="collapse"
                                data-target="#navigation" aria-controls="navigation-index" aria-expanded="false"
                                aria-label="Toggle navigation">
                            <span class="navbar-toggler-bar bar1"></span>
                            <span class="navbar-toggler-bar bar2"></span>
                            <span class="navbar-toggler-bar bar3"></span>
                        </button>
                    </div>
                </div>

                <div class="collapse navbar-collapse justify-content-end" id="navigation">
                    <div class="logo-nav-res default text-center">
                        <router-link to="/" :title="baseInfo.ShopName">
                            <img :src="baseInfo.LogoPicPath" height="36px" :title="baseInfo.ShopName" :alt="baseInfo.ShopName">
                        </router-link>
                    </div>
                    <div class="fix-tag">
                        <div @click="closeNav" class="inline-div"><router-link to="/" title="صفحه اصلی"><i class="now-ui-icons shopping_shop"></i></router-link></div>
                        <div @click="closeNav" class="inline-div">
                            <div class="router-a">
                                <router-link to="/cart" title="سبد خرید">
                                    <i class="now-ui-icons shopping_cart-simple"></i>
                                </router-link>
                                <span v-if="cart != null" class="countItem">{{  cart.CartInfo.CartDetailsCount }} </span>
                            </div>
                        </div>
                        <div @click="closeNav" class="inline-div">
                            <router-link v-if="isUserLogined" to="/info" title="پروفایل کاربری"><i class="now-ui-icons users_single-02"></i></router-link>
                            <router-link v-if="!isUserLogined" to="/login" title="ورود"><i class="now-ui-icons users_single-02"></i></router-link>
                        </div>
                    </div>
                    <hr class="hr-res" />
                    <ul class="navbar-nav default">
                        <li v-for="group in groups" class="sub-menu">
                            <a class="f-a block" :title="group.Title">
                                {{group.Title}}
                            </a>
                        
                            <i class="fa fa-align-left redirect-subGroup"  :id="group.Id"  :title="group.Title"></i>
                            <ul class="navbar-nav default">
                                <li v-for="subGruop in group.SubGroups" class="sub-menu">
                                    <a :title="subGruop.Title">{{subGruop.Title}}</a>


                                    <ul class="sub-menu sub-menu-bg">
                                        <li @click="closeNav">
                                            <router-link class="subgroub-li" :title="subGruop.Title" :to="{ name: 'filter' , query: { SubGroupId: subGruop.Id , SubGroupName: subGruop.Title.replace(/\s+/g, '-') }}">
                                                تمامی دسته ها <i class="fa fa-external-link" aria-hidden="true"></i>
                                            </router-link>
                                        </li>
                                        <li @click="closeNav" v-for="Category in subGruop.Categories">
                                            <router-link class="category-li" :title="Category.Title" :to="{name: 'filter' , query:{ CategoryId: Category.Id , CategoryName: Category.Title.replace(/\s+/g, '-') , SubGroupName: subGruop.Title.replace(/\s+/g, '-') , SubGroupId: subGruop.Id}}">{{ Category.Title }}</router-link>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
    import searchBox from "./searchBox.vue"
    export default {
        data() {
            return {
                isUserLogined: false,
            }
        },
        components: {
            'search-box': searchBox
        },
        computed: {
            groups: function () {
                return this.$store.getters.readGroups;
            },
            cart: function () {
                return this.$store.getters.readCart;
            },
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },
        beforeMount() {
            this.isUserLogined = IsNullOrEmptyString(localStorage.getItem('accessToken')) ? false : true;
        },
        methods: {
            removeSearchValue() {
                this.searchValue = '';
            },
            closeNav() {
                $(function () {
                    $('#bodyClick').click();
                });
            }
        } 
    }
    $(function () {
        $('body').on('click', '.redirect-subGroup', function () {
            var id = $(this).attr('id');
            var title = $(this).attr('title');
            window.open('/filter?GroupId='+id+'&GroupName='+title, '_Blank');
            
        });
    });
</script>

<style scoped>
    .redirect-subGroup {
        position: absolute;
        z-index: 54;
        top: 18px;
        left: 65px;
        color:#fff;
    }
        .redirect-subGroup:hover {
            cursor:pointer;
        }
        .router-a-i-m img {
            width: 25px;
            height: 30px;
        }
    .bascket-i-m {
        position: relative
    }
        .bascket-i-m .countItem  {
            position: absolute;
            right: 5px;
            top: -10px;
        }
    .top-fix-i-m {
        display: flex;
        justify-content: left;
        float: left;
     
    }
        .top-fix-i-m .router-a-i-m a {
            background-color: transparent;
            font-size: 20px;
            color: #444;
        }
        .top-fix-i-m .router-a-i-m {
            margin-left:7px;
            margin-right:7px;
        }
        .navbar-translate .navbar-Category {
            background-color: #fff;
        }

    ul.sub-menu-bg li a {
        background-color: #465157;
    }

    nav.header-responsive ul li ul li ul li .subgroub-li {
        padding-right: 50px;
    }

    .router-a {
        position: relative;
    }

        .router-a:hover .countItem {
            background-color: #5f7c12;
            color: #E5E5E5;
            transition: all .3s;
        }

    .countItem {
        position: absolute;
        right: 5px;
        top: 6px;
        background-color: #E5E5E5;
        padding: 5px;
        border-radius: 20px;
        width: 22px;
        height: 22px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #222;
    }

    .hr-res {
        border-top: 2px solid #555;
    }

    nav.header-responsive ul li ul li ul li .category-li {
        padding-right: 50px;
    }

    nav.header-responsive ul > li:hover a.f-a {
        background-color: #1d272a;
    }

    .fix-tag {
        text-align: center;
    }

        .fix-tag .inline-div {
            display: inline-block;
        }

        .fix-tag a:hover i {
            color: #5f7c12;
            transition: all .3s;
        }

        .fix-tag a i {
            font-size: 30px;
            color: #E5E5E5;
            margin: 15px;
            transition: all .3s;
        }

    @media only screen and (min-width:640px) and (max-width: 850px) {
    }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        nav.header-responsive form {
            position: relative;
            direction: rtl;
            float: right;
            height: 40px;
            width: 100%;
        }

        nav.header-responsive .search-nav ul.info-login {
            float: none;
            text-align: left;
        }

        nav.header-responsive .search-nav ul {
            width: 100%;
        }

            nav.header-responsive .search-nav ul.info-login {
                font-size: 10px !important;
                position: relative;
                top: -87px;
                left: -70px;
            }

            nav.header-responsive .search-nav ul i {
                font-size: 18px;
            }

        .js-search-keyword-link .c-search__result-item {
            font-size: 12px;
        }

        .c-search__results {
            left: 0px;
            max-height: 300px;
            overflow-y: scroll;
            padding: 0
        }

        nav.header-responsive .search-nav ul {
            overflow: auto;
        }

            nav.header-responsive .search-nav ul li {
                float: right;
            }

        nav.header-responsive .search-nav .cearchtags li a {
            display: inline;
        }

        nav.header-responsive .search-nav ul li a {
            font-size: 12px;
            color: #212121 !important;
            background: transparent;
            text-align: right;
            display: inline-block;
        }

        hr {
            display: inline-block;
            width: 100%;
        }

        .c-search__results ul li {
            line-height: 1.4;
        }

        .c-search ul li a {
            text-align: right;
        }
    }
</style>